import React, { Component } from 'react';
import { ApiClient } from '../../libs/apiClient';
import GenericTable from '../genericTable/GenericTable';
import moment from 'moment';
import $ from 'jquery';
import GenericSearchModal from '../GenericSearchModal/GenericSearchModal';
const apiClient = ApiClient.getInstance();

const userHeaders = [
    { title: "Código" },
    { title: "Nombre" },
    { title: "Eliminar" },
];

const notificationsHeaders = [
    { title: "Fecha" },
    { title: "Mensaje" },
];

// Variables para modal de búsqueda
const userSearchHeaders = [
    { title: "" },
    { title: "Código" },
    { title: "Nombre" },
];

const rowWithCheckBox = (row) => {
    return `
        <div class="input-group mb-0 justify-content-center">
            <div class="input-group-prepend">
                <span class="input-group-text form-check">
                    <input
                        type="checkbox"
                        name="finalStep"
                        id="${row.id}"
                        ${row.Check === 1 ? 'checked' : ''}
                        class="checkbox-center"
                        data-id="${row.id}"
                    />
                </span>
            </div>
        </div>
    `;
};

const userSearchCols = [
    {
        data: "Check",
        render: (data, type, row) => rowWithCheckBox(row),
        width: "10%",
    },
    {
        data: "Code",
    },
    {
        data: "Name",
    },
];

const userSearchColDefs = [
    {
        targets: '_all',
        className: 'text-center',
        orderable: false,
    },
];
class NotificationReferrals extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateFrom: moment().subtract(7, 'days').format('YYYY-MM-DD'),
            dateTo: moment(new Date()).format('YYYY-MM-DD'),
            dateMax: moment().format('YYYY-MM-DD'),
            viewModal: 'usersNoti',
            renderSearchModal: false,
            selectedUsers: [],
            userKey: '',
            Users: [],
            Notifications: [],
            dataLoaded: false,
        }

        this.refGenericSearchModal = null;
    }

    componentDidMount = async () => {
        this.getData('Users');
        this.getData('Notifications')
    }

    // Datos para el modulo
    getData = async (key) => {
        const { enableSpinner } = this.props;
        const { dateFrom, dateTo } = this.state;

        const params = {
            type: key,
            dateFrom,
            dateTo
        };

        enableSpinner(true);
        const response = await apiClient.getDataNotifTab(params);
        enableSpinner(false);

        this.setState({ [key]: response.data?.results || [] });
    }

    // Búsqueda con paginacion
    searchUsers = async (dataTablesParams, callback) => {
        const { enableSpinner, showAlert } = this.props;
        const { userKey, dataLoaded } = this.state;

        let users = [], recordsTotal = 0;

        // Parámetros de la tabla para paginar
        const currentPage = Math.floor(dataTablesParams.start / dataTablesParams.length);
        const pageSize = dataTablesParams.length;

        const params = {
            type: 'SearchUsers',
            page: currentPage || 0,
            pageSize,
            key: userKey,
        };

        enableSpinner(true);
        const response = await apiClient.getDataNotifTab(params);
        enableSpinner(false);

        // Ejecutar después de traer datos la primera vez 
        if (!dataLoaded) this.addEventsTable();

        const { status = 0, data: { results = [], recordsTotal: total }, message = '' } = response;

        if (status === 0) showAlert({ type: 'warning', message });

        if (status === 1 && results.length < 1) showAlert({ type: 'info', message: 'No hay registros para mostrar' });

        users = results;
        recordsTotal = total;

        // Actualizar datos de la tabla
        callback({
            recordsTotal,
            recordsFiltered: recordsTotal, // Necesario asignar
            data: users
        });
    };

    addEventsTable = () => {
        const { viewModal } = this.state;

        // Agregando evento de selección a los checkbox
        $(`#${viewModal}-Table`).on('change', 'input[type="checkbox"]', (e) => {
            const { target, target: { checked } } = e;
            const id = $(target).data('id');
            this.addUsers(checked, id);
        });

        $(`#${viewModal}`).modal('show');
        this.setState({ dataLoaded: true });
    }

    showSearchModal = async () => {
        const { dataLoaded, viewModal } = this.state;
        if (dataLoaded) $(`#${viewModal}`).modal('show');

        this.setState({ renderSearchModal: true });
    }

    addUsers = async (value, id) => {
        this.setState((prevState) => {
            const { selectedUsers } = prevState;
            const userIndex = selectedUsers.findIndex(user => user.id === id);

            if (userIndex === -1) {
                return {
                    selectedUsers: [...selectedUsers, { Check: value, id }]
                };
            }
        });

        const success = await this.userOperations(id, value);

        // Si se agrego y no se actualiza se desmarca
        if (value && !success) {
            const checkbox = document.getElementById(id);
            if (checkbox) checkbox.checked = false
        }
    }

    userOperations = async (id, add = true) => {
        const { enableSpinner, showAlert } = this.props;

        if (!id) showAlert({ type: 'warning', message: 'No logramos obtener el id del usuario seleccionado' });

        const params = {
            operation: add ? 'new' : 'update',
            id
        };

        enableSpinner(true);
        const response = await apiClient.userOperationsNotifTab(params);
        enableSpinner(false);

        const { status = 0, message = '' } = response;
        if (status === 0) {
            showAlert({ type: 'warning', message });
            return false;
        }

        if (!add) {
            this.setState(prevState => ({
                Users: prevState.Users.filter(user => user.id !== id)
            }));
        }

        return true;
    }

    unMountModal = () => {
        const { selectedUsers } = this.state;

        // Si se seleccionaron usuarios refrescamos registros
        if (selectedUsers.length > 0) this.getData('Users');

        this.setState({ renderSearchModal: false, dataLoaded: false, selectedUsers: [] });
    }

    onChangeInputs = (e) => {
        const { name, value } = e.target;

        this.setState({ [name]: value });
    }

    onChangeSearch = (value) => {
        this.setState({ userKey: value });
    }

    render() {
        const { dateFrom, dateTo, dateMax, viewModal, renderSearchModal, Users, Notifications } = this.state;
        return (
            <div className="content">
                {renderSearchModal &&
                    <GenericSearchModal
                        view={viewModal}
                        title={'Buscar usuarios'}
                        headers={userSearchHeaders}
                        columns={userSearchCols}
                        columnDefs={userSearchColDefs}
                        enableSearchInTable={true}
                        onChangeSearch={this.onChangeSearch}
                        getData={this.searchUsers}
                        unMountModal={this.unMountModal}
                    />
                }
                <div className="row g-3">
                    <div className="col-12 col-lg-6">
                        <h3 className="text-center">Usuarios</h3>
                        <div className="mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-transparent text-success"
                                        onClick={this.showSearchModal}
                                    >
                                        <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                                        <span>Agregar</span>
                                    </button>
                        </div>
                        <GenericTable
                            headers={userHeaders}
                            data={Users}
                            view={'notiRefT1'}
                            idTable={'notiRefT1'}
                            enableSearchInTable={false}
                            action={this.userOperations}
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <h3 className="text-center">Historial de notificaciones</h3>
                        <div className="row g-2 mb-3 align-items-center">
                            <div className="col-12 col-sm-5 mb-2">
                                <div className="input-group">
                                        <span className="input-group-text font-weight-bold">Desde</span>
                                    <input
                                        id="iDateFrom"
                                        className="form-control"
                                        type="date"
                                        name="dateFrom"
                                        value={dateFrom}
                                        max={dateMax}
                                        onChange={this.onChangeInputs}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-sm-5 mb-2">
                                <div className="input-group">
                                        <span className="input-group-text font-weight-bold">Hasta</span>
                                    <input
                                        id="iDateTo"
                                        className="form-control"
                                        type="date"
                                        name="dateTo"
                                        value={dateTo}
                                        max={dateMax}
                                        onChange={this.onChangeInputs}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-sm-2 d-flex justify-content-start justify-content-sm-center">
                                <button className="btn btn-outline-dark" title="Actualizar" onClick={() => this.getData('Notifications')} > <i className="fa fa-refresh" /> </button>
                            </div>
                        </div>

                        <GenericTable
                            headers={notificationsHeaders}
                            data={Notifications}
                            view={'notiRefT2'}
                            idTable={'notiRefT2'}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default NotificationReferrals;